// extracted by mini-css-extract-plugin
export default {"root":"PDFViewer_root__LY4M3"};